import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Accordion } from "react-bootstrap";

import Layout from "../components/Layout";
import arrowDown from "../assets/img/arrow-down.png";

import Footer from "../components/Footer";
import Header from "../components/Header";

import faqImg from "../assets/images/faq.jpg";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

const Faq = () => {
  const [activeKey, setActiveKey] = useState("");
  useEffect(() => {
    AOS.init({
      duration: 2300,
      once: true,
    });
  }, []);
  return (
    <Layout>
      <Header />
      <header
        className="masthead faqhead"
        style={{
          backgroundImage: `url(${faqImg})`,
          backgroundPosition: "top right",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          height: "auto",
        }}
      >
        <div className="overlay overlay2" />
        <div className="container d-flex h-100 align-items-center container pb-5 pt-md-5 pb-md-5">
          <Accordion onSelect={(e) => setActiveKey(e)}>
            <h3 className="d-block text-center mb-4">
              frequently asked questions
            </h3>
            <Accordion.Toggle as={Button} variant="link" eventKey="0">
              <p className="m-0 position-relative">
                as a customer, how can i get access to PckitUp’s service?
                {activeKey === "0" ? (
                  <img className="down" src={arrowDown} alt="" />
                ) : (
                  <img className="up" src={arrowDown} alt="" />
                )}
              </p>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <p>
                  all you need to do is download our customer app on your ios or
                  android smart phone and register. with the app on your phone,
                  you can easily request to have a driver come to your location
                  to pick up your garbage and recycling, super simple!
                </p>
              </Card.Body>
            </Accordion.Collapse>
            <Accordion.Toggle as={Button} variant="link" eventKey="1">
              <p className="m-0 position-relative">
                how can I sign up to be a PckitUp agent?
                {activeKey === "1" ? (
                  <img className="down" src={arrowDown} alt="" />
                ) : (
                  <img className="up" src={arrowDown} alt="" />
                )}
              </p>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <Card.Body>
                <p>
                  simple download the app from the app store or google play,
                  then sign up, get approved, and you are ready to go.
                </p>
              </Card.Body>
            </Accordion.Collapse>
            <Accordion.Toggle as={Button} variant="link" eventKey="2">
              <p className="m-0 position-relative">
                how often do you pick up my trash?
                {activeKey === "2" ? (
                  <img className="down" src={arrowDown} alt="" />
                ) : (
                  <img className="up" src={arrowDown} alt="" />
                )}
              </p>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="2">
              <Card.Body>
                <p>
                  this is a true on-demand service, which means the frequency
                  and time is all up to you. just schedule the garbage pickup
                  and consider it gone.
                </p>
              </Card.Body>
            </Accordion.Collapse>
            <Accordion.Toggle as={Button} variant="link" eventKey="3">
              <p className="m-0 position-relative">
                do i need to wait for an agent to pick up my garbage?
                {activeKey === "3" ? (
                  <img className="down" src={arrowDown} alt="" />
                ) : (
                  <img className="up" src={arrowDown} alt="" />
                )}
              </p>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="3">
              <Card.Body>
                <p>
                  no need to wait for the agent to pick up your trash. simply
                  schedule the pickup, and place the trash in agreed upon
                  location. once the trash has been removed, you will get a
                  notification that the task is complete on your PckitUp app.
                </p>
              </Card.Body>
            </Accordion.Collapse>
            <Accordion.Toggle as={Button} variant="link" eventKey="4">
              <p className="m-0 position-relative">
                would i need to sign a contract?
                {activeKey === "4" ? (
                  <img className="down" src={arrowDown} alt="" />
                ) : (
                  <img className="up" src={arrowDown} alt="" />
                )}
              </p>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="4">
              <Card.Body>
                <p>
                  no contract, no upfront costs, no hassle. you pay per
                  transaction which is transparent to both you and the driver.
                  super easy
                </p>
              </Card.Body>
            </Accordion.Collapse>
            <Accordion.Toggle as={Button} variant="link" eventKey="5">
              <p className="m-0 position-relative">
                what kinds of waste do you handle?
                {activeKey === "5" ? (
                  <img className="down" src={arrowDown} alt="" />
                ) : (
                  <img className="up" src={arrowDown} alt="" />
                )}
              </p>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="5">
              <Card.Body>
                <p>
                  we handle basic household trash, recycling, home hazardous
                  waste, and yard waste. just let us know on that app and we’ll
                  handle the rest.
                </p>
              </Card.Body>
            </Accordion.Collapse>
          </Accordion>
        </div>
      </header>
      <section className="mt-5 mb-5 container">
        <div className="row">
          <div className="col-lg-6 text-center">
            <a
              href="/apply/#agent"
              className="btn btn-primary faqButton faqButtonAgent"
            >
              Agent app
            </a>
          </div>
          <div className="col-lg-6 text-center">
            <a
              href="/apply/#customer"
              className="btn btn-success faqButton faqButtonCustomer m-0"
            >
              Customer app
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </Layout>
  );
};

export default Faq;
